/**
 * Upload domain types and Zod schemas
 *
 * ARCH-5: File content stored in R2, metadata in D1
 * ARCH-29: R2 key format logos/{ulid}.{ext}
 */

import { z } from "zod";

// ─── Constants ───────────────────────────────────────────────────
export const ALLOWED_CONTENT_TYPES = [
	"image/png",
	"image/jpeg",
	"image/webp",
	"image/svg+xml",
] as const;

export type AllowedContentType = (typeof ALLOWED_CONTENT_TYPES)[number];

/** 2 MB in bytes */
export const MAX_UPLOAD_SIZE = 2_097_152;

// ─── Schemas ─────────────────────────────────────────────────────
export const UploadContentTypeSchema = z.enum([
	"image/png",
	"image/jpeg",
	"image/webp",
	"image/svg+xml",
]);

export const UploadResponseSchema = z.object({
	id: z.string(),
	url: z.string(),
});

export type UploadResponse = z.infer<typeof UploadResponseSchema>;

// ─── Domain Entity ───────────────────────────────────────────────
export const UploadSchema = z.object({
	id: z.string(),
	tokenId: z.string().nullable(),
	fileName: z.string(),
	contentType: z.string(),
	sizeBytes: z.number().int(),
	r2Key: z.string(),
	uploaderWallet: z.string().nullable(),
	createdAt: z.string(),
});

export type Upload = z.infer<typeof UploadSchema>;
